// extracted by mini-css-extract-plugin
export default {"fv_area":"FirstView_fv_area__0Ctqd","count":"FirstView_count__8Q07N","num_wrapper":"FirstView_num_wrapper__8nXEq"};